// import ikon za zastave
import allIcon from "../assets/icon-globe.png";
import enIcon from "../assets/icons8-great-britain-48.png";
import siIcon from "../assets/icons8-slovenia-48.png";

export const flagLang = [
  { title: "English", avatar: enIcon, langShort: "en" },
  { title: "Slovenščina", avatar: siIcon, langShort: "sl" }
];

export const flagLangAll = [
  { title: "/", avatar: allIcon, langShort: "/" },
  { title: "English", avatar: enIcon, langShort: "en" },
  { title: "Slovenščina", avatar: siIcon, langShort: "sl" }
];
